import type { ReactNode } from 'react'
import { BrowserRouter } from 'react-router-dom'

import { QueryProvider } from './query-provider'
import { HeroUIRouterProvider } from './router-provider'

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <QueryProvider>
      <BrowserRouter>
        <HeroUIRouterProvider>{children}</HeroUIRouterProvider>
      </BrowserRouter>
    </QueryProvider>
  )
}
